(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ryl-about-link-fixes"] && !Shopify.designMode) return;
  try {
    
(function () {
  function fixAboutDestinations() {
    var work = document.querySelector('.ryl-about66__why-work-cta');
    var wellness = document.querySelector('.ryl-about66__wellness-cta');
    if (work) work.setAttribute('href', '/pages/work-with-meg');
    if (wellness) wellness.setAttribute('href', '/pages/rise-within-wellness');

    var nextLinks = document.querySelectorAll('.ryl-about66__next a');
    if (nextLinks[0]) nextLinks[0].setAttribute('href', '/collections');
    if (nextLinks[1]) nextLinks[1].setAttribute('href', '/pages/lift-up-others');
    if (nextLinks[2]) nextLinks[2].setAttribute('href', '/pages/contact');
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', fixAboutDestinations, { once: true });
  } else {
    fixAboutDestinations();
  }
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ryl-create-your-light"] && !Shopify.designMode) return;
  try {
    
document.querySelectorAll('.ryl-create').forEach(root => {
  const form = root.querySelector('#CreateYourLightRequest');
  if (!form) return;
  const path = root.querySelector('[data-ryl-visual-path]');
  const fields = root.querySelector('#CYLFormFields');
  const piece = root.querySelector('#CYLPiece');
  const intention = root.querySelector('#CYLIntention');
  const collection = root.querySelector('#CYLCollection');
  const shapes = [root.querySelector('#CYLShape'), root.querySelector('#CYLShapeBackup')];
  const colors = [root.querySelector('#CYLColorFirst'), root.querySelector('#CYLColorBackup')];
  const modes = root.querySelectorAll('input[name="ryl-visual-level"]');
  const svg = (kind) => {
    const art = {
      ring:'<circle cx="32" cy="41" r="16"/><path d="m24 18 8-10 8 10-8 11z"/>',
      earrings:'<path d="M18 9v13m28-13v13M18 22c-7 8-6 19 0 28 6-9 7-20 0-28zm28 0c-7 8-6 19 0 28 6-9 7-20 0-28z"/>',
      necklace:'<path d="M9 11c3 22 11 33 23 33S52 33 55 11"/><path d="m32 39-8 9 8 9 8-9z"/>',
      keychain:'<circle cx="24" cy="20" r="10"/><path d="M31 27l17 17m-8-8 8-8m-4 12 8-8"/>',
      infuser:'<path d="M14 22h36l-4 22H18zM21 44c0 12 22 12 22 0M22 22v-8h20v8"/>',
      round:'<circle cx="32" cy="32" r="20"/>',
      oval:'<ellipse cx="32" cy="32" rx="15" ry="23"/>',
      teardrop:'<path d="M32 7C27 20 14 30 14 42a18 18 0 0 0 36 0C50 30 37 20 32 7z"/>',
      rectangle:'<rect x="15" y="10" width="34" height="44" rx="3"/>',
      heart:'<path d="M32 53 12 34C1 22 16 8 32 23 48 8 63 22 52 34z"/>',
      star:'<path d="m32 6 7 17 18 1-14 12 5 18-16-10-16 10 5-18L7 24l18-1z"/>',
      grounding:'<path d="M32 8v30m-15-14c5-12 25-12 30 0M32 37c-7 1-13 7-15 17m15-17v19m0-19c7 1 13 7 15 17M12 56h40"/>',
      calm:'<path d="M7 28c8-5 16-5 24 0s17 5 26 0M7 40c8-5 16-5 24 0s17 5 26 0M10 52c7-4 14-4 21 0s15 4 23 0"/><circle cx="44" cy="13" r="6"/>',
      connection:'<circle cx="15" cy="17" r="6"/><circle cx="49" cy="17" r="6"/><path d="M7 39c0-10 16-10 16 0m18 0c0-10 16-10 16 0M32 53 21 43c-7-8 3-16 11-7 8-9 18-1 11 7z"/>',
      growth:'<path d="M32 56V32m0 12c-10 0-17-7-17-17 10 0 17 7 17 17zm0-11c0-11 8-18 18-18 0 11-8 18-18 18zM14 56h36"/>',
      clarity:'<circle cx="32" cy="31" r="12"/><path d="M32 5v8m0 36v8M6 31h8m36 0h8M14 13l6 6m24 24 6 6m0-36-6 6M20 43l-6 6"/>',
      release:'<path d="M11 45c13-1 24-8 31-21M24 39c-3-10 2-17 9-22 0 10-2 17-9 22zm10-7c5-5 12-6 19-4-5 6-12 8-19 4zM10 55c5-1 9-3 12-6"/>',
      intuition:'<path d="M42 9a21 21 0 1 0 13 34A22 22 0 0 1 42 9zM13 12v8m-4-4h8m31 1v7m-4-4h8"/>',
      celebration:'<path d="m25 25 7 30 7-30-7-8zM11 12l5 5m34-5-5 5M8 34h8m32 0h8M23 7l2 7m16-7-2 7m-23 34 4-5m28 5-4-5"/>',
      unsure:'<circle cx="32" cy="32" r="23"/><path d="M24 24c0-10 16-12 17-1 1 7-9 8-9 15m0 7v2"/>'
    };
    return '<svg viewBox="0 0 64 64" aria-hidden="true" focusable="false">'+(art[kind]||art.unsure)+'</svg>';
  };
  const choices = (container, items, handler) => {
    items.forEach(item => {
      const button = document.createElement('button');
      button.type='button';
      button.dataset.value=item.value;
      button.setAttribute('aria-pressed','false');
      button.innerHTML=(item.color?'<span class="ryl-create__swatch" style="--swatch:'+item.color+'"></span>':svg(item.icon))+'<span>'+item.label+'</span>';
      button.addEventListener('click', () => handler(item.value,button,container));
      container.append(button);
    });
  };
  const single = (value,button,container,target) => {
    target.value=value;
    container.querySelectorAll('button').forEach(b=>b.setAttribute('aria-pressed',String(b===button)));
  };
  const pieceItems = [
    ['Keychain — $20','Keychain','keychain'],['Tea Infuser — $20','Tea infuser','infuser'],
    ...['Ring','Earrings','Necklace'].flatMap(type=>['Small','Medium','Large'].map(size=>[size+' '+type+' — $'+({Ring:{Small:30,Medium:40,Large:50},Earrings:{Small:40,Medium:50,Large:60},Necklace:{Small:40,Medium:50,Large:60}}[type][size]),size+' '+type.toLowerCase(),type.toLowerCase()])),
    ['Not sure — help me choose','Help me choose','unsure']
  ].map(([value,label,icon])=>({value,label,icon}));
  choices(root.querySelector('[data-ryl-pieces]'),pieceItems,(value,button,container)=>single(value,button,container,piece));
  const intentions=['Grounding / stability','Calm / peace','Connection / love','Growth / confidence','Clarity / focus','Release / renewal','Intuition / transformation','Celebration / self-expression','Not sure — help me choose'];
  choices(root.querySelector('[data-ryl-intentions]'),intentions.map((value,index)=>({value,label:value.split(' / ')[0],icon:['grounding','calm','connection','growth','clarity','release','intuition','celebration','unsure'][index]})),(value,button,container)=>single(value,button,container,intention));
  const pickTwo=(value,button,container,targets,result,label)=>{
    const pressed=[...container.querySelectorAll('button[aria-pressed="true"]')];
    if(button.getAttribute('aria-pressed')==='true'){
      button.setAttribute('aria-pressed','false');
      const remaining=pressed.filter(b=>b!==button);
      targets.forEach((t,i)=>t.value=remaining[i]?.dataset.value||'');
    }else{
      if(pressed.length===2)pressed[0].setAttribute('aria-pressed','false');
      button.setAttribute('aria-pressed','true');
      const selected=pressed.length===2?[pressed[1],button]:[...pressed,button];
      targets.forEach((t,i)=>t.value=selected[i]?.dataset.value||'');
    }
    result.textContent='First '+label+': '+(targets[0].value||'none yet')+' · Backup: '+(targets[1].value||'none yet');
  };
  root.querySelectorAll('[data-ryl-collections] button').forEach(button=>button.addEventListener('click',()=>{
    collection.value=button.dataset.collection;
    root.querySelectorAll('[data-ryl-collections] button').forEach(other=>other.setAttribute('aria-pressed',String(other===button)));
  }));
  const shapeBox=root.querySelector('[data-ryl-shapes]');
  choices(shapeBox,['Round','Oval','Teardrop','Rectangle','Heart','Star'].map(x=>({value:x,label:x,icon:x.toLowerCase()})),(v,b,box)=>pickTwo(v,b,box,shapes,root.querySelector('[data-ryl-shape-result]'),'shape'));
  const colorBox=root.querySelector('[data-ryl-colors]');
  choices(colorBox,[['Blue','#4778aa'],['Green','#61936d'],['Purple','#9165a9'],['Pink','#df9db7'],['Red','#c54b53'],['Orange','#e69b56'],['Yellow','#f0ce60'],['White','#fff'],['Black','#252525'],['Clear','#e6f0ee']].map(([value,color])=>({value,label:value,color})),(v,b,box)=>pickTwo(v,b,box,colors,root.querySelector('[data-ryl-color-result]'),'color'));
  const updateMode=()=>{
    const mode=root.querySelector('input[name="ryl-visual-level"]:checked').value;
    path.dataset.mode=mode;fields.dataset.mode=mode;
    piece.required=mode!=='high';
    root.querySelectorAll('[data-ryl-level="high"]').forEach(el=>{el.hidden=mode!=='high'});
  };
  modes.forEach(m=>m.addEventListener('change',updateMode));updateMode();
  form.addEventListener('submit',event=>{
    if(path.dataset.mode==='high'&&!piece.value){
      event.preventDefault();
      root.querySelector('[data-ryl-pieces] button').focus();
      root.querySelector('[data-ryl-pieces]').before(Object.assign(document.createElement('p'),{textContent:'Please choose a piece above, or choose “Help me choose.”',className:'ryl-create__errors'}));
    }
  });
});

  } catch(e) { console.error(e); }
})();
})();
